//export default const backendURL = "https://treasury-trip.up.railway.app";
const backendURL = "https://treasury-trip.onrender.com";

export default backendURL;
